// eslint-disable-next-line import/prefer-default-export
export const ADD_MARKETINGSITES = 'ADD_MARKETINGSITES';
